<form class="flex flex-column" (validate)="save()" novalidate validation-es>
  <ms-common-person-form name="personForm" [(ngModel)]="person"></ms-common-person-form>

  <div class="align-self-end">
    <button pButton [type]="loading ? 'button' : 'submit'" [label]="screen.actions.save"
      [icon]="loading ? loadingIcon : 'far fa-save'" iconPos="left" class="p-button-success p-button-outlined"></button>
  </div>
</form>